import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import moment from 'moment';
import { Observable } from 'rxjs';
import * as z from 'zod';

import { Project } from '../schemas';
import { storedResource } from '../shared';
import { Lambda } from './lambda';
import { Messenger } from './messenger';

@Injectable({ providedIn: 'root' })
export class ProjectsService {
  private http = inject(HttpClient);

  private url = inject(Lambda).getProjectsUrl();

  private readonly CACHE_KEY = `lcm:service-cache:project`;

  private projectsResource = httpResource(() => this.url, {
    defaultValue: JSON.parse(window.localStorage.getItem(this.CACHE_KEY) || '[]'),
    parse: z.array(Project).parse,
  });

  constructor() {
    storedResource(this.projectsResource, this.CACHE_KEY, inject(Messenger));
  }

  projects = this.projectsResource.value;
  pending = this.projectsResource.isLoading;

  reload() {
    this.projectsResource.reload();
  }

  delete(id: string): Observable<unknown> {
    const request = this.http.delete<unknown>(this.url + '/' + id);

    return request;
  }

  save(instance: Project, forEdit = false): Observable<Project> {
    instance = { ...instance };
    if (moment.isMoment(instance.StartDate)) {
      instance.StartDate = instance.StartDate.format('Y-MM-DD');
    }
    if (moment.isMoment(instance.EndDate)) {
      instance.EndDate = instance.EndDate.format('Y-MM-DD');
    }

    delete (instance as Partial<Project>).Milestones;
    delete (instance as Partial<Project>).PurchasedHours;

    if (!instance.PurchaseOrder) delete (instance as Partial<Project>).PurchaseOrder;

    let request: Observable<Project>;
    if (forEdit) {
      request = this.http.put<Project>(this.url + '/' + instance.Id, instance);
    } else {
      request = this.http.post<Project>(this.url, instance);
    }

    return request;
  }
}
